//____ TABS SWITCH CONTENT ____ //
//____ AUTHOR: LUBOMÍR BLAŽEK ____ //
function nl_fn_switch_content(nl_fn_switch_class) {
    $(".switch-content").hide();
    $(".switch-content.active").show();
    var button = $(nl_fn_switch_class).find(".switch-nav").find(".switch-button");
    var content = $(nl_fn_switch_class).find(".switch-area").find(".switch-content");
    content.each(function(n) {
        var button_class = ("item-" + n);
        $(this).addClass(button_class);
    });
    button.each(function(n) {
        var button_class = ("item-" + n);
        $(this).addClass(button_class);
        $(this).on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("active")) {
                $(this).closest(".switch-nav").find(".switch-button").removeClass("active");
                $(this).addClass("active");
                $(this).parents(nl_fn_switch_class).find(".switch-area").find(".switch-content").hide().removeClass("active");
                $(this).parents(nl_fn_switch_class).find(".switch-area").find(".switch-content").closest(".switch-area").find("."+ button_class).fadeIn();
                /*$(".sc-slider").slick('unslick');
                $(".sc-slider").slick('init');*/
            }
        });
    });
}